import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
});

// Attach Bearer token if present (fallback to cookie auth)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("yacrrd_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const fileUrl = (urlOrPath) => {
    if (!urlOrPath) return "";
    if (urlOrPath.startsWith("http")) return urlOrPath;
    if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
    return urlOrPath;
};

export default api;
